export const HELLO_EMAIL = "hello@formfunction.xyz";

export const MAILTO_HELLO_EMAIL = `mailto:${HELLO_EMAIL}`;
